var map = {
	"./bg.json": 387062,
	"./ca.json": 934753,
	"./cs.json": 781111,
	"./da.json": 146406,
	"./de.json": 964906,
	"./el.json": 734640,
	"./en-IN.json": 171934,
	"./es-419.json": 295990,
	"./es.json": 708545,
	"./et.json": 327960,
	"./fi.json": 969604,
	"./fr.json": 184137,
	"./hr.json": 865467,
	"./hu.json": 948902,
	"./is.json": 885349,
	"./it.json": 176740,
	"./ja.json": 441984,
	"./kl.json": 831066,
	"./ko.json": 250283,
	"./lt.json": 555517,
	"./lv.json": 489315,
	"./nl.json": 264723,
	"./no.json": 540418,
	"./pl.json": 326689,
	"./pt-BR.json": 520420,
	"./pt.json": 893817,
	"./ro.json": 652878,
	"./ru.json": 908356,
	"./sl.json": 353250,
	"./sv.json": 858008,
	"./uk.json": 501129,
	"./vi.json": 513588,
	"./zh-CN.json": 519239,
	"./zh-TW.json": 929799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 854910;